import { compact } from "lodash";
import { ErrorResponse } from "@apollo/client/link/error";

export const allApolloErrorsToString = (err: ErrorResponse) =>
  compact(err.graphQLErrors)
    .map((e) => e.message)
    .join("\n");
